import CardCredentialOtpScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialOtpScreen/CardCredentialOtpScreen';
import React from 'react';

export default function BelieveFundingP2PCardCredentialOtpPage() {
  return (
    <CardCredentialOtpScreen
      returnPath="/believe-funding/p2p/debit"
      errorReturnToCardDetail
    />
  );
}
